import type { TrustedTypePolicyFactory, TrustedTypePolicyOptions } from 'trusted-types/lib';

export function addTrustedTypesPolyfill(): void {
    // In case trustedTypes is not supported by the browser: https://github.com/w3c/trusted-types?tab=readme-ov-file#tinyfill
    if (typeof window.trustedTypes === 'undefined') {
        window.trustedTypes = {
            createPolicy: (name: string, rules: TrustedTypePolicyOptions) => rules
        } as TrustedTypePolicyFactory;
    }
}
